import StudentCurriculumDetailPage from "./StudentCurriculumDetailPage";

export default StudentCurriculumDetailPage;